/**
 * Panther Vision - product title stars
 * Fetches YouNet/EZ under-title stars; mounts under mobile h2 + desktop h1.
 * Renames app classes and plants a hidden .rev-titl-wp guard so the app
 * does not skip/duplicate under-title inject.
 */
(function () {
  'use strict';

  var API = 'https://dev.younet.network/importreview';
  var STYLE_ID = 'pv-title-stars-style';
  var CLICK = 'pv-rev-titl-wp';

  function productId() {
    var id = (window.meta && window.meta.product && window.meta.product.id) ||
      (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id);
    if (id) {
      return String(id);
    }
    var el = document.querySelector('[data-product-id]');
    return el ? el.getAttribute('data-product-id') : null;
  }

  function shop() {
    return (window.Shopify && window.Shopify.shop) || 'panther-vision-store.myshopify.com';
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '[data-pv-title-stars] { display: block !important; }',
      '[data-pv-title-stars] .' + CLICK + ' {',
      '  display: inline-block; width: 100%; padding: 5px 0 10px; cursor: pointer;',
      '}',
      '[data-pv-title-stars] .nub-rev-tt {',
      '  float: left; margin-left: 5px; padding-top: 5px; font-size: 16px;',
      '}',
      '[data-pv-title-stars] .light-str-i {',
      '  text-align: left; word-break: keep-all !important; white-space: nowrap;',
      '}',
      'header.mobile-hide .ez-rv-under-title { display: block !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function plantAppGuard() {
    if (document.querySelector('[data-pv-star-guard]')) {
      return;
    }
    var guard = document.createElement('div');
    guard.className = 'rev-titl-wp';
    guard.setAttribute('data-pv-star-guard', '1');
    guard.setAttribute('aria-hidden', 'true');
    guard.style.cssText = 'display:none!important;width:0;height:0;overflow:hidden;position:absolute;';
    document.documentElement.appendChild(guard);
  }

  function recalcWidth(root) {
    var dark = root.querySelector('.dark-str-i');
    var light = root.querySelector('.light-str-i');
    if (!dark || !light) {
      return;
    }
    requestAnimationFrame(function () {
      var w = dark.getBoundingClientRect().width;
      if (w) {
        light.style.width = (w * 0.932) + 'px';
      }
    });
  }

  function bindScroll(root) {
    var el = root.querySelector('.' + CLICK);
    if (!el) {
      return;
    }
    el.addEventListener('click', function (e) {
      var target = document.getElementById('ra-al-reviw') ||
        document.querySelector('[id*="ra-al"], #section-reviews');
      if (!target) {
        return;
      }
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function cleanedHtml(html) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    wrap.querySelectorAll('script, style').forEach(function (n) {
      n.remove();
    });
    wrap.querySelectorAll('.ez-rv-under-title').forEach(function (n) {
      n.classList.remove('ez-rv-under-title');
      n.classList.add('pv-rv-under-title');
    });
    wrap.querySelectorAll('.rev-titl-wp').forEach(function (n) {
      n.classList.remove('rev-titl-wp');
      n.classList.add(CLICK);
    });
    return wrap.innerHTML;
  }

  function mount(anchor, placement, html) {
    if (!anchor || document.querySelector('[data-pv-title-stars="' + placement + '"]')) {
      return;
    }
    var holder = document.createElement('div');
    holder.setAttribute('data-pv-title-stars', placement);
    holder.innerHTML = html;
    if (!holder.querySelector('.' + CLICK)) {
      return;
    }
    anchor.insertAdjacentElement('afterend', holder);
    recalcWidth(holder);
    setTimeout(function () {
      recalcWidth(holder);
    }, 300);
    bindScroll(holder);
  }

  function insert(html) {
    ensureStyles();
    plantAppGuard();
    var body = cleanedHtml(html);
    mount(
      document.querySelector('header.mobile-only h2.m5, header.mobile-only h2'),
      'mobile',
      body
    );
    if (!document.querySelector('header.mobile-hide .ez-rv-under-title .rev-titl-wp')) {
      mount(
        document.querySelector('header.mobile-hide h1.m5, header.mobile-hide h1'),
        'desktop',
        body
      );
    }
  }

  function init() {
    if (document.querySelector('[data-pv-title-stars]')) {
      return;
    }
    var id = productId();
    if (!id) {
      return;
    }
    var url = API + '/ajaxGetTitleStar/' + encodeURIComponent(id) +
      '?shop=' + encodeURIComponent(shop()) +
      '&product_id=' + encodeURIComponent(id);

    fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Title star request failed: ' + res.status);
        }
        return res.text();
      })
      .then(function (html) {
        if (html && html.trim()) {
          insert(html);
        }
      })
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[pv-title-stars]', err);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
